export default "__VITE_ASSET__CwhlTKEP__"